export function satoshiToMCH(x) {
    if(x == null) return "";
    var satoshi = Number(x);
    var mch = satoshi / 100000000;
    return numberWithCommas(mch);
}
function numberWithCommas(x) {
  if(x == null) return "";
  let num = x.toString();
  let strArray = num.split('.');
  if(strArray.length > 1) {
    return strArray[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "." + strArray[1];
  } else {
    return num.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
}
// 숫자형으로 리턴
export function satoshiToMCHNumber(x) {
  if(x == null) return "";
  var satoshi = Number(x);
  var mch = satoshi / 100000000;
  return Number(mch);
}
// mch to 사토시
export function mchToSatosi(x) {
  if(x == null) return "";
  var mch = Number(x);
  var satoshi = (mch * 100000000).toFixed(0);
  return String(satoshi);
}